import { Injectable } from '@angular/core';
import { firstValueFrom, map, Observable } from 'rxjs';
import { PQRTamanhoTurmaDto } from '../../dtos/pqr-tamanho-turma.dto';
import { environment } from '../../../environments/environment';
import { CaqRequestService } from '../'

interface ListPQRTamanhoTurma {
  _embedded: {
    'pqr-tamanho-turma': PQRTamanhoTurmaDto[];
  };
}

@Injectable({
  providedIn: 'root',
})
export class PQRTamanhoTurmaService {
  private apiUrl = `${environment.apiUrl}/pqr-tamanho-turma`;

  constructor(
    private caqRequestService: CaqRequestService
  ) {}

  buscarListaDePQRTamanhoTurma(): Observable<PQRTamanhoTurmaDto[]> {
    return this.caqRequestService
      .get<ListPQRTamanhoTurma>(this.apiUrl)
      .pipe(map((response) => response._embedded['pqr-tamanho-turma']));
  }

  salvePQRTamanhoTurma(requisicao: PQRTamanhoTurmaDto){
    return firstValueFrom(this.caqRequestService
      .put<PQRTamanhoTurmaDto>(`${this.apiUrl}/${requisicao.codPqrTamanhoTurma}`, requisicao)
      .pipe(map((response) => response)));
  }
}
